import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import Config from '../../../../../Config';

const TextList = (props) => {

    useEffect(() => { }, []);

    return (
        <div className='text-list-wrapper'>
            {
                props.textList.map((item, index) => {
                    if (item.title) {
                        return (
                            <div key={index} className='text-list-title'> {item.title} </div>
                        )
                    }
                    else {
                        return (
                            <div key={index} className={`text-item ${item.isBoldText ? 'bold-text' : ''}`}>
                                <div className='icon-wrapper'> {getIcon(item.icon)} </div>
                                <span> {item.text} </span>
                            </div>
                        )
                    }
                })
            }
        </div>
    );

    function getIcon(iconType) {
        switch (iconType) {
            case 0: return '';
            case 1: return <Image src={require('./images/light-black-icon.svg')} />;
            case 2: return <Image src={require('./images/light-gray-icon.svg')} />;
            case 3: return <Image src={require('./images/wifi-icon.svg')} />;
            case 4: return <Image src={require('./images/bill-icon.svg')} />;
            case 5: return <Image src={require('./images/phone-icon.svg')} />;
            case 6: return <Image src={require('./images/esim-icon.svg')} />;
            case 7: return <Image src={require('./images/sim-icon.svg')} />;
            case 8: return <Image src={require('./images/checkmark-purple-icon.svg')} />;
            case 9: return <Image src={require('./images/checkmark-gray-icon.svg')} />;
            case 10: return <Image src={require('./images/apple-icon.svg')} />;
            case 11: return <Image src={require('./images/android-icon.svg')} />;
            case 12: return <Image src={require('./images/alert-icon.svg')} />;
            default: return '';
        }
    }
};

export default TextList;
